import { Injectable } from '@angular/core';
import { AuthorizationService } from '@app/services/authorization.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ArisJmsMessage } from '@app/models/aris-jms-message';

@Injectable({
  providedIn: 'root'
})
export class ArisMessageService {

  constructor(private authorizationService: AuthorizationService, ) { }

  public send(messageCode: number, acctRep: string, account: string) {
    let arisJmsMessage: ArisJmsMessage = new ArisJmsMessage();
    arisJmsMessage.type = "ArisJmsMessage"
    arisJmsMessage.messageType = messageCode;
    arisJmsMessage.arCode = acctRep;
    arisJmsMessage.account = account;
    this.authorizationService.sendArisJmsMessage(arisJmsMessage).subscribe({
      next: (s: any) => {
        // Note: The response body is a map. Decide if/how a response should be modeled.
        console.log(s);
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
      }
    });
  }
}
